exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Upu_1{position:relative;background:#000}.Upu_1 ._3Msyw{display:block;position:absolute;width:100%;height:100%;top:0}.Upu_1 ._1_w45{position:relative;z-index:125;background-color:#000}.Upu_1 ._1_w45+._3Msyw{visibility:hidden}", ""]);

// exports
exports.locals = {
	"player": "Upu_1",
	"player-wrapper": "_3Msyw",
	"playerWrapper": "_3Msyw",
	"overlay": "_1_w45"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/player-widget/components/new-player/player.styl
// module id = 1471
// module chunks = mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals widget/strip widget/classic widget/compact